import { definePreset } from '@openng/optimus-ui-themes';
import Aura from '@openng/optimus-ui-themes/aura';

/**
 * Optimus UI's Aura with the compact density of @primeuix/themes@3.0.0 Aura, which the app used
 * before the switch from PrimeNG. Only tokens of the rendered components (Table, Select,
 * MultiSelect with its Checkbox and filter input, VirtualScroller) that differ between the two
 * presets are overridden; aura-compact.expected.json pins the full resolved result.
 */
const sizes = {
  padding: '0.5rem 0.875rem',
  sm: { padding: '0.125rem 0.375rem' },
  lg: { padding: '0.75rem 1.125rem' },
};

const listTokens = {
  dropdown: { width: '2.25rem' },
  option: { padding: '0.25rem 0.625rem' },
  optionGroup: { padding: '0.25rem 0.625rem' },
  emptyMessage: { padding: '0.25rem 0.625rem' },
};

export const AuraCompact = definePreset(Aura, {
  semantic: {
    iconSize: '0.875rem',
    // Select, MultiSelect and the overlay filter inputs read their padding from formField.
    formField: {
      paddingX: '0.625rem',
      paddingY: '0.375rem',
      sm: { fontSize: '0.75rem', paddingX: '0.5rem', paddingY: '0.25rem' },
      lg: { fontSize: '1rem', paddingX: '0.75rem', paddingY: '0.5rem' },
    },
  },
  components: {
    // MultiSelect renders a Checkbox per option and for toggle-all.
    checkbox: {
      root: {
        width: '1.125rem',
        height: '1.125rem',
        sm: { width: '0.875rem', height: '0.875rem' },
        lg: { width: '1.25rem', height: '1.25rem' },
      },
      icon: { size: '0.75rem', sm: { size: '0.625rem' }, lg: { size: '0.875rem' } },
    },
    datatable: {
      root: { transitionDuration: '0s' },
      header: sizes,
      headerCell: {
        ...sizes,
        selectedBackground: '{content.background}',
        selectedColor: '{content.color}',
      },
      bodyCell: sizes,
      footerCell: sizes,
      footer: sizes,
      sortIcon: { size: '0.75rem' },
      loadingIcon: { size: '1.75rem' },
      rowToggleButton: { size: '1.5rem' },
      filter: {
        overlayPopover: { padding: '0.625rem' },
        constraint: { padding: '0.25rem 0.625rem' },
      },
    },
    select: {
      ...listTokens,
      list: { header: { padding: '0.5rem 0.875rem 0.125rem 0.875rem' } },
      checkmark: { gutterStart: '-0.25rem', gutterEnd: '0.25rem' },
    },
    multiselect: {
      ...listTokens,
      list: { header: { padding: '0.5rem 0.5rem 0.125rem 0.875rem' } },
      option: {
        ...listTokens.option,
        focusColor: '{list.option.color}',
        selectedBackground: 'transparent',
        selectedColor: '{list.option.color}',
        selectedFocusBackground: 'transparent',
        selectedFocusColor: '{list.option.color}',
      },
    },
    virtualscroller: {
      loader: { icon: { size: '1.75rem' } },
    },
  },
});
